export default __webpack_public_path__ + "static/media/_calculator_beroas_active.ec6d79fd.svg";